import { jsx as _jsx } from "react/jsx-runtime";
import { Divider, Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import mimeTypeLabels from '../../common/mimeTypeLabels';
dayjs.extend(localizedFormat);
const DocumentInfoBar = ({ document, }) => {
    // const tokens = useTokens();
    const type = mimeTypeLabels[document?.asset?.mimeType] || '-';
    const publishedDate = document?.publishedAt ? dayjs(document.publishedAt).format('ll') : '';
    // const duration = document?.asset?.duration ? document?.asset?.duration : '';
    return (_jsx(Stack, { direction: "row", divider: _jsx(Divider, { orientation: "vertical", flexItem: true }), sx: { marginY: 'auto', width: 1 }, justifyContent: "space-between", alignItems: "center", children: [
            type,
            publishedDate,
        ].map((text, index) => (_jsx(Typography
        // eslint-disable-next-line react/no-array-index-key
        , { component: "div", className: "courseDisplayCourseInfoBarText", children: text }, index))) }));
};
export default observer(DocumentInfoBar);
//# sourceMappingURL=DocumentInfoBar.js.map